/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { getRichTextHtml, IImageSettings, Image } from '@msdyn365-commerce/core';
import { MailingFormComponent, mailingFormUserInfo } from './mailing-form';
import { IMailingListData } from './mailing-list.data';
import { IMailingListProps } from './mailing-list.props.autogenerated';

// ==============================================================================
// CLASS DEFINITIONS
// ==============================================================================
/**
 *
 * ColsolareMailingList component
 * @extends {React.Component<IMailingListProps<IMailingListData>>}
 */
class MailingList extends React.Component<IMailingListProps<IMailingListData>> {

    // ==========================================================================
    // PUBLIC METHODS
    // ==========================================================================

    public constructor(props: IMailingListProps<IMailingListData>) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
    }

    public render(): JSX.Element {
        return (
            <div className='row'>
                {this._formPage}
                {this._backgroundImage}
            </div>
        );
    }

    // ==========================================================================
    // COMPONENT EVENTS
    // ==========================================================================

    private _onSubmit(userInfo: mailingFormUserInfo): void {
        console.log(userInfo);

        // TODO: send info to add to contact form via data action then change
        // page state

        console.log('%cUser will be navigated away from this page and to a confirmation page', 'color: green; font-size:55px;');
        console.log(`%c${this.props.config.confirmationURL} <--- url to use`, 'color: green; font-size:25px;');

    }

    // ==========================================================================
    // COMPONENT PAGES
    // ==========================================================================

    private get _backgroundImage(): JSX.Element | null {
        const image = this.props.config.imageURL;

        const defaultImageSettings: IImageSettings = {
            viewports: {
                xs: { q: `w=24&h=24&m=6`, w: 0, h: 0 },
                lg: { q: `w=24&h=24&m=6`, w: 0, h: 0 }
            },
            lazyload: true
        };

        if (image) {
            return (
                <div className='col-8 mailing-list-image'>
                    <Image
                        {...image}
                        gridSettings={this.props.context.request.gridSettings!}
                        imageSettings={image.imageSettings || defaultImageSettings}
                    />
                </div>
            );
        }
        return null;
    }

    private get _formPage(): JSX.Element {
        const {
            marketingContactSupport,
            marketingDescription
        } = this.props.config;
        return (
            <div className={`mailing-list ${this._mailingListColType}`}>
                <h1>Mailings</h1>
                {
                    marketingDescription &&
                    // tslint:disable-next-line:react-no-dangerous-html
                    <p
                        className='mailing-list-header-info'
                        dangerouslySetInnerHTML={getRichTextHtml(marketingDescription)}
                    />
                }
                <h2>Please Enter Your Information</h2>
                <MailingFormComponent
                    onSubmit={this._onSubmit}
                />
                {
                    marketingContactSupport &&
                    // tslint:disable-next-line:react-no-dangerous-html
                    <label
                        className='mailing-list-contact'
                        dangerouslySetInnerHTML={getRichTextHtml(marketingContactSupport)}
                    />
                }
            </div>
        );
    }

    private get _mailingListColType(): string {
        return (this.props.config.imageURL) ? 'col-4' : 'col';
    }
}

export default MailingList;
